/**
 * AdminInstallLogsRpcClient - AtomRpc integration for admin install-logs
 * endpoints (`admin/installs/logs.list` + `admin/installs/logs.stream`).
 *
 * Drives the install-detail Logs tab — historical scrollback via NDJSON
 * paginated reads, plus live tail via the streaming endpoint. Requires
 * admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { InstallLogsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminInstallLogsRpcClient extends AtomRpc.Tag<AdminInstallLogsRpcClient>()(
  "AdminInstallLogsRpcClient",
  {
    group: InstallLogsRpcs,
    protocol: makeRpcClientLayer(InstallLogsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
